import { render, staticRenderFns } from "./MailListArray.vue?vue&type=template&id=c38e0094"
import script from "./MailListArray.vue?vue&type=script&lang=js"
export * from "./MailListArray.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports